import { PageParam } from '@/models/page/page-param';
import { WebFormConfigModel, WebformLanguage } from '@/models/web-form.model';

import Api, { useRequest, useRequestPage } from '@/api';

export function useListWebFormConfig() {
  return useRequestPage<WebFormConfigModel[], PageParam>(Api.webFormsWithPage);
}

export function useGetWebFormConfigById() {
  return useRequest<WebFormConfigModel>(Api.webFormsDetail);
}

export function useDeleteWebFormConfig() {
  return useRequest(Api.webFormsDelete);
}

export type CreateWebFormConfigType = {
  website_url: string;
  data_list: Array<Record<'form_id' | 'touchpoint', string> & Record<'language', WebformLanguage>>;
};
export function useCreateWebFormConfig() {
  return useRequest<WebFormConfigModel, CreateWebFormConfigType>(Api.webFormsCreate);
}

export type EmailTouchpointsParamsType = {
  active: boolean;
} & PageParam;
type EmailTouchpointsResType = {
  direction: 'INBOUND' | 'OUTBOUND' | 'BOTH';
  email: string;
  friendly_name: string;
};
export function useEmailTouchpoints() {
  return useRequestPage<EmailTouchpointsResType[], EmailTouchpointsParamsType>(Api.emailTouchpoints);
}

export function useUpdateWebFormConfig() {
  return useRequest<WebFormConfigModel, CreateWebFormConfigType>(Api.webFormsUpdate);
}
